import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    completeUrl: String,
  };

  static targets = ["confirmCashInstructions", "submitButton"];

  connect() {
  }

  submit(event) {
    // Use Stimulus's dispatch for cross-controller validation
    const validationEvent = this.dispatch("validate-form", { cancelable: true });
    if (validationEvent.defaultPrevented) {
      event.preventDefault();
      return;
    }

    if (!this.confirmCashInstructionsTarget.checked) {
      event.preventDefault();
      this.confirmCashInstructionsTarget.setCustomValidity("Please confirm that you have read and agree to the instructions before proceeding.");
      this.confirmCashInstructionsTarget.reportValidity();
      return;
    }

    this.confirmCashInstructionsTarget.setCustomValidity("");
    this.submitButtonTarget.disabled = true;
    Turbo.visit(this.completeUrlValue, { action: "advance" });
  }
}